<template>
  <div class="dialog">
    <el-dialog
      class="formExportAis"
      :visible.sync="changVisible"
      center
      width="600px"
      :modal="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      :before-close="$onClose"
      destroy-on-close
    >
      <el-form id="form_exportAis" method="post" v-loading="loading">
        <input type="input" name="export_ids" :value="export_ids" />
        <input type="input" name="fields" :value="fields" />
        <input type="input" name="order" :value="order" />
        <input type="input" name="where_student_no" :value="where_student_no" />
        <input type="input" name="where_name" :value="where_name" />
        <input type="input" name="where_programme" :value="where_programme" />
        <input type="input" name="where_honor_time" :value="where_honor_time" />
        <input type="input" name="where_content" :value="where_content" />
        <input
          type="input"
          name="where_alumni_type"
          :value="where_alumni_type"
        />
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import { URL_PATH } from "@/config/config";
import * as StrUtils from "@/utils/strUtils.js";
import * as Constant from "@/utils/constant.js";
import * as CApi from "@/api/constant_api.js";

export default {
  data() {
    return {
      export_ids: "",
      changVisible: false,
      loading: true,
      token: localStorage.getItem("token"),
      fields: "",
      order: "",
      where_student_no: "",
      where_name: "",
      where_programme: "",
      where_honor_time: "",
      where_content: "",
      where_alumni_type: ""
    };
  },
  methods: {
    $onClose(done) {
      done();
    },
    close() {
      this.changVisible = false;
    },
    //页面初始化时加载的事件
    show(
      checkList,
      order,
      where_student_no,
      where_name,
      where_programme,
      where_honor_time,
      where_content,
      where_alumni_type,
      ids
    ) {
      if (ids) {
        this.export_ids = ids;
      } else {
        this.export_ids = "";
      }
      this.changVisible = true;
      this.fields = StrUtils.getHonorInfoFields(checkList);
      this.order = order;
      this.where_student_no = where_student_no;
      this.where_name = where_name;
      this.where_programme = StrUtils.replaceFields(where_programme.toString());
      this.where_honor_time =
        where_honor_time.length == 0
          ? ""
          : where_honor_time[0] + "-" + where_honor_time[1];
      this.where_content = where_content;
      if (where_alumni_type != null) {
        this.where_alumni_type = StrUtils.replaceFields(
          where_alumni_type.toString()
        );
      }
      this.$nextTick(() => {
        const from = document.getElementById("form_exportAis");
        from.action =
          URL_PATH + CApi.api_exportAisHonor + "?token=" + this.token;
        from.submit();
        this.close();
      });
    }
  }
};
</script>

<style lang="less" scoped>
.formExportAis {
  visibility: hidden;
}
input {
  visibility: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/dialog/exportAisHonorDialog.vue